import React from 'react'

const Sectors = () => {
    return (
        <div className='landing-container-sectors'>
            <div className='landing-container-sectors-wrapper'>
                <div className="landing-container-sectors-wrapper-content">
                    <h1>Sektorleri inceleyin.</h1>
                    <p>Detayli sektor hakkinda bilgi almak istiyor iseniz,</p>
                    <button>Sektorleri incele</button>
                </div>
                <img src='https://derinerpartners.com/assets/img/brochure.png'></img>
            </div>
        </div>
    )
}

export default Sectors
